import cx from "clsx";
import { CLIENT_ENV } from "kreate-env/client";
import React from "react";
import { RemoveScroll } from "react-remove-scroll";

import RibbonCarousel from "../NavbarV3/containers/RibbonCarousel";
import { useRibbonCarouselApi } from "../NavbarV3/containers/RibbonCarousel/hooks";

import NavbarOnly$Market from "./containers/NavbarOnly$Market";
import { useIsScrolledToTop } from "./hooks/useIsScrolledToTop";
import styles from "./index.module.scss";
import { Product } from "./types";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  product: Product;
  hideRibbonCarousel?: boolean;
  makeTransparentUnlessScrolledDown?: boolean;
  hideSearchBar?: boolean;
};

export default function NavbarV4({
  className,
  style,
  product,
  hideRibbonCarousel,
  makeTransparentUnlessScrolledDown,
  hideSearchBar,
}: Props) {
  if (product !== "market" && CLIENT_ENV.CARDANO_NETWORK !== "Mainnet") {
    // loudly alert to the developer
    alert("unsupported product: " + product);
  }
  const isScrolledToTop = useIsScrolledToTop({
    disabled: !makeTransparentUnlessScrolledDown,
  });

  const ribbonCarouselApi = useRibbonCarouselApi({
    disabled: hideRibbonCarousel,
  });

  const renderContent = () => {
    return (
      <>
        {!hideRibbonCarousel ? (
          <RibbonCarousel api={ribbonCarouselApi} />
        ) : undefined}
        <NavbarOnly$Market
          background={isScrolledToTop ? "transparent" : "solid"}
          hideSearchBar={hideSearchBar}
        />
      </>
    );
  };

  return (
    <div className={cx(styles.container, className)} style={style}>
      <div
        className={cx(
          styles.fixedAndVisible,
          // https://github.com/theKashey/react-remove-scroll#positionfixed-elements
          RemoveScroll.classNames.zeroRight
        )}
      >
        {renderContent()}
      </div>
      <div className={styles.staticAndInvisible}>{renderContent()}</div>
    </div>
  );
}
